import { useHistory } from 'react-router-dom'

import { Auth } from '@scouts/auth'
import { ButtonLink, Flexer } from '@taxfix/scouts-ui'

import { PATH_RESET_PASSWORD, PATH_SIGNUP } from '@/constants'

const Footer = () => {
    const history = useHistory()

    return (
        <Flexer column gap="12px" alignCenter>
            <ButtonLink onClick={() => history.push(PATH_RESET_PASSWORD)}>Forgot password? Reset password</ButtonLink>

            <ButtonLink onClick={() => history.push(PATH_SIGNUP)}>Don't have an account? Sign up here</ButtonLink>
        </Flexer>
    )
}

export const Login = () => {
    return (
        <Auth.LockscreenLayout title="Log in to Taxfix" footer={<Footer />}>
            <Auth.LoginForm />
        </Auth.LockscreenLayout>
    )
}
